export enum Path {
  ANALYTICS_XVVS = '/info-xvvs',
}
